var EmailPreferenceCenter = (function () {
  
  var utility = window.Utility;

  var $emailPreferenceCenter;
  var $preferencesListForm;
  var $updateEmailForm;
  var $updateButton;
  var $unsubscribeButton;
  var $updateEmailButton;
  var $emailPreferencesButton;
  var $serverMessage;
  var $successContainer;
  var $formsContainer;
  var $overlay;
  var $updateEmailError;
  var urlData;
  var configurationItem;

  const getCheckboxLegal = 'input[name=legal]';

  // Get URL variables and return them as an associative array.
  function getUrlVariables() {
    const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    var parametersObject = utility.getUrlParameters();
    var businessEntity = '';
    var email = '';

    if (!jQuery.isEmptyObject(parametersObject)) {
      for (var key in parametersObject) {
        if (base64regex.test(parametersObject[key])) {
          parametersObject[key] = window.atob(parametersObject[key]);
        }

        switch (key.toLowerCase()) {
          case 'qs':
            var dataArray = parametersObject[key].split('&');
            businessEntity = dataArray[0];
            email = dataArray[1];
            break;
          case 'businessentity':
            businessEntity = parametersObject[key];
            break;
          case 'emailid':
            if (parametersObject[key].indexOf('&') >= 0) {
              businessEntity = parametersObject[key].substr(0, parametersObject[key].indexOf('&'));
            }
            email = parametersObject[key].substr(parametersObject[key].indexOf('&') + 1);
            break;
        }
      }
    }

    configurationItem = $emailPreferenceCenter.find('.js-configuration-item').text();

    urlData = {
      businessEntity: businessEntity,
      email: email,
      configurationItem: configurationItem,
    };

    $emailPreferenceCenter.find('.js-current-user-email').html(urlData.email);
  }

  // Gets the data to check the inputs preferences of the user
  function getData() {
    var getDataUrl = $preferencesListForm.attr('get-data-url');
    getUrlVariables();

    $.ajax({
      beforeSend: function () {
        showSpinnerOverlay();
      },
      method: 'POST',
      data: JSON.stringify(urlData),
      url: getDataUrl,
      contentType: 'application/json; charset=utf-8',
      success: function (response) {
        if (response) {
          var options = response.split(',');
          options.forEach(function (option) {
            var $checkbox = $preferencesListForm.find('input[name=' + option + ']'); // Finds the checkbox with the same name of the option
            $checkbox.prop('checked', true); // Set the property "checked" to the checkbox
          });
        }
        hideSpinnerOverlay();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
        showServerMessage(jqXHR.responseJSON);
      },
    });
  }

  function createDataJson(form) {
    var dataJson;

    if (form.className.indexOf('js-preferences-list-form') >= 0) {
      var interests = [];
      var unsubscribe = [];

      for (var key = 0; key < Object.keys(form).length; key++) {
        if (form[key] !== undefined && form[key].type === 'checkbox') {
          if (form[key].checked) {
            interests.push(form[key].name);
          } else {
            unsubscribe.push(form[key].name);
          }
        }
      }

      dataJson = {
        businessEntity: urlData.businessEntity,
        interests: interests,
        unsubscribe: unsubscribe,
        firstName: '',
        lastName: '',
        email: urlData.email,
        configurationItem: configurationItem,
      };
    } else {
      var newEmail = form.elements.Email.value;
      dataJson = {
        businessEntity: urlData.businessEntity,
        email: urlData.email,
        newEmail: newEmail,
        configurationItem: configurationItem,
      };
    }

    return dataJson;
  }

  function sendData(form) {
    var action = $(form).attr('action');
    var data = createDataJson(form);

    $.ajax({
      beforeSend: function () {
        showSpinnerOverlay();
      },
      data: JSON.stringify(data),
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
        showServerMessage(jqXHR.responseJSON);
      },
      success: function (data) {
        showServerMessage(data);
      },
      url: action,
    });
  }

  function enableUpdateEmailButton() {
    var email = this.value;
    if (!Validation.isValidEmail(email)) {
      $updateEmailButton.attr('disabled', true);
    } else {
      $updateEmailButton.removeAttr('disabled');
    }
  }

  function clearForm() {
    $preferencesListForm.find('input').prop('checked', false);
    $updateEmailForm.find('input').val('');
    $updateEmailForm.find('input').removeClass('acr-not-empty');
    $updateEmailButton.attr('disabled', true);
  }

  function updateURL(querystring) {
    if (history.replaceState) {
      var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?qs=' + querystring;
      window.history.replaceState({ path: newUrl }, '', newUrl);
    }
  }

  function showForm(event) {
    var querystring = event.currentTarget.getAttribute('querystring');
    clearForm();
    $updateButton.attr('disabled', true);
    if (querystring) {
      updateURL(querystring);
    }
    getData();
    $serverMessage.addClass('hidden');
    $successContainer.addClass('hidden');
    $formsContainer.removeClass('hidden');
  }

  function showSpinnerOverlay() {
    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, { passive: false });
    $('body').css('overflow', 'hidden');
    $overlay.removeClass('hidden');
  }

  function hideSpinnerOverlay() {
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);
    $('body').css('overflow', 'auto');
    $overlay.addClass('hidden');
  }

  function showServerMessage(data) {
    if (data) {
      data = $.parseJSON(data);
    }

    hideSpinnerOverlay();
    if (data.successMsg) {
      if (data.querystring) {
        $emailPreferencesButton.attr('querystring', data.querystring);
      }
      $serverMessage.html(data.successMsg);
      $emailPreferencesButton.html(data.buttonLabel);
      $formsContainer.addClass('hidden');
      $serverMessage.removeClass('message--error');
      $serverMessage.removeClass('hidden');
      $successContainer.removeClass('hidden');
    } else {
      $serverMessage.addClass('message--error');
      $serverMessage.html(data.errorMsg);
      $serverMessage.removeClass('hidden');
    }
    window.scrollTo(0, 0);
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }

  function attachEvents() {
    // Enable the "Update" button when the checkboxes change
    $preferencesListForm.find('input').change(function () {
      $updateButton.removeAttr('disabled');
    });

    // Call the method to send the preferences list form data
    $preferencesListForm.submit(function (event) {
      sendData(event.target);
      event.preventDefault();
    });

    // Call the method to clear the form data
    $unsubscribeButton.on('click', clearForm);

    // Call events when new email input changes
    $updateEmailForm.find('input')
      .on('keyup', enableUpdateEmailButton)
      .on('focus', Validation.onFocus)
      .on('blur', Validation.onBlur);

    // Call the method to send the new email form data
    $updateEmailForm.submit(function (event) {
      var $checkboxLegal = $updateEmailForm.find(getCheckboxLegal);
      if ($checkboxLegal.is(':checked')) {
        sendData(event.target);
      } else {
        $updateEmailError.css('display', 'block');
      }
      event.preventDefault();
    });

    // Call the method to show the email preference center form
    $emailPreferencesButton.off('click', showForm)
      .on('click', showForm);
  }

  function getQuerySelectors() {
    $emailPreferenceCenter = $('.js-email-preference-center');
    $preferencesListForm = $emailPreferenceCenter.find('.js-preferences-list-form');
    $updateEmailForm = $emailPreferenceCenter.find('.js-update-email-form');
    $updateButton = $preferencesListForm.find('.js-update-cta');
    $unsubscribeButton = $preferencesListForm.find('.js-unsubscribe-cta');
    $updateEmailButton = $updateEmailForm.find('.js-update-email-cta');
    $emailPreferencesButton = $emailPreferenceCenter.find('.js-email-preferences-button');
    $serverMessage = $emailPreferenceCenter.find('.js-server-message');
    $successContainer = $emailPreferenceCenter.find('.js-success-container');
    $formsContainer = $emailPreferenceCenter.find('.js-forms-container');
    $overlay = $emailPreferenceCenter.find('.js-overlay');
    $updateEmailError = $updateEmailForm.find('.js-update-email-error');
  }

  function init() {
    getQuerySelectors();
    if ($emailPreferenceCenter.length > 0) {
      getData();
      attachEvents();
    }
  }

  return {
    init: init,
  };
}());
